export default "__VITE_ASSET__BZWx$zOk__"